
import { useState, useEffect } from "react";
import { Button } from "./Button";
import { Divider } from "@mui/material";

export const CustomModal = ({
    title,
    onClose,
    children,
    onApply,
    onEditPaper,
    modalOpen,
    width,
    disabled,
    buttonText,
    editButtonText,
}) => {
    // Local state to track when the modal is fully closed
    const [isVisible, setIsVisible] = useState(modalOpen);

    // Handle modal visibility changes with animation
    useEffect(() => {
        if (modalOpen) {
            setIsVisible(true);
        } else {
            // Wait for the animation to finish before removing the modal
            const timer = setTimeout(() => setIsVisible(false), 300); // Match animation duration
            return () => clearTimeout(timer);
        }
    }, [modalOpen]);

    return (
        isVisible && (
            <div
                className={`fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50 transition-opacity duration-300 ${modalOpen ? "opacity-100" : "opacity-0"
                    }`}
            >
                <div
                    className={`bg-white rounded-lg p-4 sm:p-6 w-full ${width} overflow-y-auto transform transition-transform duration-300 ${modalOpen ? "scale-100" : "scale-90"
                        }`}
                >
                    <div className="flex justify-between items-center mb-4">
                        <div></div>
                        <h2 className="text-xl font-bold">{title}</h2>
                        <button
                            onClick={onClose}
                            className="text-gray-500 hover:text-gray-700"
                        >
                            X
                        </button>
                    </div>
                    <Divider />
                    <div className="space-y-4">{children}</div>
                    <div style={{ marginTop: "16px", display: "flex", gap: "10px" }}>
                        {onApply && (
                            <Button
                                disabled={disabled}
                                onClick={onApply}
                                label={buttonText}
                            />
                        )}
                        {/* {onEditPaper && (
              <Button onClick={onEditPaper} label={editButtonText} />
            )} */}
                    </div>
                </div>
            </div>
        )
    );
};
